import styled, { DefaultTheme } from 'styled-components';
import { space, typography } from 'styled-system';
import getThemeValue from '../../util/getThemeValue';
import {
  getBodyTextFontSize,
  getHeadlineFontSize,
  getSubtitleFontSize
} from './text.utils';
import { TextProps } from './types';

interface ThemedProps extends TextProps {
  theme: DefaultTheme;
}

const getColor = ({ color, theme }: ThemedProps) => {
  return getThemeValue(`colors.${color}`, color)(theme);
};

export const Text = styled.div<TextProps>`
  display: flex;
  align-items: center;
  font-family: inherit;
  color: ${getColor};
  font-size: ${({ fontSize }) => fontSize ?? '14px'};
  font-weight: ${({ bold }) => (bold ? 600 : 500)};
  line-height: 1.5;
  ${({ textTransform }) => textTransform && `text-transform: ${textTransform};`}
  ${space}
  ${typography}
`;

export const Headline = styled.div<TextProps>`
  color: ${getColor};
  font-size: ${getHeadlineFontSize};
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  line-height: 1.5;
  ${({ textTransform }) => textTransform && `text-transform: ${textTransform};`}
`;

export const Subtitle = styled.div<TextProps>`
  color: ${getColor};
  font-size: ${getSubtitleFontSize};
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  line-height: 1.5;
  ${({ textTransform }) => textTransform && `text-transform: ${textTransform};`}
`;

export const BodyText = styled.div<TextProps>`
  color: ${getColor};
  font-size: ${getBodyTextFontSize};
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  line-height: 1.5;
  ${({ textTransform }) => textTransform && `text-transform: ${textTransform};`}
`;

export const CaptionText = styled.div`
  color: ${getColor};
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
`;

export const TooltipText = styled.div`
  color: ${getColor};
  font-weight: 400;
  font-size: 10px;
  line-height: 20px;
`;
